import { PERMISSION_SUBJECTS } from '@/helpers/casl/ability';

import { useQueryDocumentById } from '@/hooks/query/useQueryDocumentById';
import { TabType } from '@heidi/session/contracts';
import { useSessionWindow, useSessionWindows } from '@heidi/session/data';

import { useIsReviewingOtherUser } from '@/hooks/query/useQueryUser';
import { useSessionPermissionCheck } from '@/hooks/useSessionPermissionCheck';
import { useCurrentSessionId } from '@heidi/runtime/shell';
import { selectedReviewMemberAtom } from '@heidi/workspace/data';
import { useAtomValue } from 'jotai';

export const useHasPermissionToReplace = () => {
  const sessionId = useCurrentSessionId();
  const { activeWindowIndex } = useSessionWindows({ sessionId });
  const { activeTab } = useSessionWindow({ sessionId, windowIndex: activeWindowIndex });

  const tabName = activeTab?.name;
  const documentId = activeTab?.documentId ?? '';
  const { data: currentDocument } = useQueryDocumentById({
    sessionId,
    documentId,
    select: (data) => {
      if (!data) return undefined;
      return {
        creator_kinde_id: data.creator_kinde_id,
      };
    },
  });
  const { checkPermission } = useSessionPermissionCheck(sessionId);
  const isReviewingOtherUser = useIsReviewingOtherUser();
  const selectedReviewMember = useAtomValue(selectedReviewMemberAtom);
  const isOwnerPrimaryDocument =
    isReviewingOtherUser &&
    (currentDocument?.creator_kinde_id === selectedReviewMember ||
      tabName !== TabType.DOCUMENT);

  const hasAskAiEditPermission = checkPermission(
    PERMISSION_SUBJECTS.ASK_AI_EDIT,
    PERMISSION_SUBJECTS.ASK_AI_EDIT
  );

  const hasPermissionToReplace = hasAskAiEditPermission && !isOwnerPrimaryDocument;

  return { hasPermissionToReplace };
};
